// frontend/src/components/cohesion/tourPrefs.ts
// UX-02 (2026-06 UX audit) — local cache for tour seen/skip state.
//
// The source of truth is users.ui_preferences on the server
// (/api/users/me/ui-preferences). localStorage is ONLY a cache:
// - on every successful GET the cache is replaced with the server's
//   tour-related keys (server wins, including un-dismissals),
// - dismissals/skip-all merge into the cache optimistically so other
//   mounted surfaces suppress immediately while the PUT is in flight.

const CACHE_KEY = 'sw-tour-prefs'

export function readTourPrefsCache(): Record<string, unknown> {
  try {
    const raw = localStorage.getItem(CACHE_KEY)
    return raw ? (JSON.parse(raw) as Record<string, unknown>) : {}
  } catch {
    return {}
  }
}

function write(prefs: Record<string, unknown>): void {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(prefs))
  } catch { /* quota / private mode — cache is best-effort */ }
}

/** Replace the cache with the server's tour-related keys. Server wins. */
export function writeTourPrefsCacheFromServer(prefs: Record<string, unknown>): void {
  const tourKeys: Record<string, unknown> = {}
  for (const [k, v] of Object.entries(prefs || {})) {
    if (k === 'tours_disabled_at' || k.startsWith('tour_')) tourKeys[k] = v
  }
  write(tourKeys)
}

/** Optimistically merge a dismissal patch into the cache. */
export function mergeTourPrefsCache(patch: Record<string, unknown>): void {
  write({ ...readTourPrefsCache(), ...patch })
}
